export default {
  cookieDomain: process.env.VUE_APP_COOKIE_DOMAIN || "localhost",
  serverUrl: process.env.VUE_APP_CV_SERVER_URL || "http://localhost:3000",
  appUrl: process.env.VUE_APP_URL || "http://localhost:8080",
};
